const setStatus = (statusEl, message, isError = false) => {
	if (!statusEl) {
		return;
	}
	statusEl.textContent = message;
	statusEl.classList.toggle('is-error', isError);
};

const wireDemoHooks = (mount) => {
	const snackbar = mount.querySelector('#js-demo-snackbar');
	const showSnackbar = mount.querySelector('#js-show-snackbar');
	if (snackbar && showSnackbar) {
		showSnackbar.addEventListener('click', () => {
			snackbar.show?.('Your details have been saved.');
		});
	}

	const errorSnackbar = mount.querySelector('#js-demo-error-snackbar');
	const showError = mount.querySelector('#js-show-error-snackbar');
	if (errorSnackbar && showError) {
		showError.addEventListener('click', () => {
			errorSnackbar.show?.('We were unable to save your changes. Please try again.');
		});
	}

	const counter = mount.querySelector('#counter-demo, lta-counter');
	const counterLog = mount.querySelector('#js-counter-demo-event-log');
	if (counter && counterLog) {
		counter.addEventListener('counter-change', (event) => {
			const { oldValue, newValue } = event.detail || {};
			counterLog.textContent = `Event: counter-change ${oldValue} → ${newValue}`;
		});
	}

	const datePickerLog = mount.querySelector('.js-date-picker-event-log, #js-date-picker-demo-event-log');
	mount.querySelectorAll('lta-date-picker').forEach((datePicker) => {
		datePicker.addEventListener('lta-date-change', (event) => {
			const { value } = event.detail || {};
			if (datePickerLog) {
				datePickerLog.textContent = `Event: lta-date-change ${value || '(cleared)'}`;
			}
			// Demo only: clear forced error styling once a date is chosen
			if (value && datePicker.getAttribute('has-error') === 'true') {
				datePicker.setAttribute('has-error', 'false');
			}
		});
	});

	const overlayModal = mount.querySelector('#overlay-modal-demo');
	const openOverlay = mount.querySelector('#js-open-overlay-modal-demo');
	const overlayLog = mount.querySelector('#js-overlay-modal-demo-event-log');
	if (overlayModal && openOverlay) {
		openOverlay.addEventListener('click', () => {
			overlayModal.isOpen = true;
		});
		if (overlayLog) {
			overlayModal.addEventListener('overlay-modal-dismiss', () => {
				overlayLog.textContent = 'Event: overlay-modal-dismiss';
			});
			overlayModal.addEventListener('overlay-modal-submit', () => {
				overlayLog.textContent = 'Event: overlay-modal-submit';
				overlayModal.isOpen = false;
			});
		}
	}

	const lockedOverlayModal = mount.querySelector('#overlay-modal-locked-demo');
	const openLockedOverlay = mount.querySelector('#js-open-overlay-modal-locked-demo');
	const lockedOverlayLog = mount.querySelector('#js-overlay-modal-locked-demo-event-log');
	if (lockedOverlayModal && openLockedOverlay) {
		openLockedOverlay.addEventListener('click', () => {
			lockedOverlayModal.isOpen = true;
		});
		if (lockedOverlayLog) {
			lockedOverlayModal.addEventListener('overlay-modal-dismiss', () => {
				lockedOverlayLog.textContent = 'Event: overlay-modal-dismiss';
			});
		}
	}
};

const applyMarkup = (card) => {
	const textarea = card.querySelector('.js-wc-playground-markup');
	const mount = card.querySelector('.js-wc-playground-mount');
	const statusEl = card.querySelector('.js-wc-playground-status');

	if (!textarea || !mount) {
		return;
	}

	const markup = textarea.value.trim();

	if (!markup) {
		setStatus(statusEl, 'Markup is empty', true);
		return;
	}

	try {
		mount.innerHTML = markup;
		wireDemoHooks(mount);
		mount.dispatchEvent(
			new CustomEvent('wc-playground:applied', {
				bubbles: true,
				detail: { markup }
			})
		);
		setStatus(statusEl, 'Preview updated from markup', false);
	} catch (error) {
		setStatus(statusEl, `Render error: ${error.message}`, true);
		// eslint-disable-next-line no-console
		console.error(error);
	}
};

const initCard = (card) => {
	const applyButton = card.querySelector('.js-wc-playground-apply');
	const textarea = card.querySelector('.js-wc-playground-markup');

	const apply = () => applyMarkup(card);

	applyButton?.addEventListener('click', apply);
	textarea?.addEventListener('keydown', (event) => {
		if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
			event.preventDefault();
			apply();
		}
	});

	apply();
};

const boot = () => {
	document.querySelectorAll('.js-wc-playground-card').forEach(initCard);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
